<template>
    <div class="service">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing bgRed" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h3 class="title2">6大增值服务，为教培机构保驾护航</h3>
                <div class="marker"></div>
            </div>
            <div class="item-contents">
                <ul>
                    <li v-for="(x,index) in item1_list" :class='{"jqhover":x.hover_}' @mouseenter="x.hover_ = true"  @mouseleave="leaveItem1()">
                        <div class="image">
                            <img :src="'static/img/service/item1_'+(index+1)+'.png'" alt="">
                        </div>
                        <div class="title_info">
                            <div class="info" v-show="!x.hover_"><{{x.title}}></div>
                            <div class="info" v-show="x.hover_">{{x.info}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_2">
            <div class="item-title">
                <h3 class="title2">为教培机构搭建远程教育平台</h3>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item2_list" :class='{"jqhover":x.hover_}' @mouseenter="x.hover_ = true"  @mouseleave="leaveItem1()">
                        <div class="title">{{x.title}}</div>
                        <div class="image">
                            <img :src="'static/img/service/item2_'+(index+1)+'.png'" alt="">
                        </div>
                        <div class="info">{{x.info}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_3">
            <div class="item-title">
                <h3 class="title2">千校辅导，见证机构蜕变</h3>
                <div class="marker"></div>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item3_list" >
                        <div class="image">
                            <img :src="'static/img/service/item3_'+(index+1)+'.png'"  width='100%' height='100%' alt="">
                        </div>
                        <div class="title">{{x.title}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_4">
            <div class="item-title">
                <h3 class="title2">常见问题及解答</h3>
                <div class="marker"></div>
            </div>
            <div class="item-contents center">
                <ul class="info">
                    <li>
                        <div class="question">Q：为什么我无法激活账号？</div>
                        <div class="answer">A: 请联系您的校长或者负责人，在“行政管理”-“员工管理”内查看是否已添加您为该校区员工。添加好后，即可激活账号。</div>
                    </li>
                    <li>
                        <div class="question">Q：我录入了一个学员，怎么找不到了？</div>
                        <div class="answer">A:  您应该只是录入了学员基本信息，还没有报读课程，可以到“潜客管理”中搜索该学员姓名，录入报读课程信息即可。</div>
                    </li>
                </ul>
            </div>
        </div>
        <shen-qing></shen-qing>
    </div>
</template>

<script>
     import shenQing from "./shenqing.vue";
export default {
    components:{
        shenQing
    },
    data(){
        return{
            item1_list:[
                {title:"数据安全",info:"银行级数据安全保障"},
                {title:"7*24h在线",info:"客服7*24h快速响应"},
                {title:"免费升级",info:"系统每周免费自动升级"},
                {title:"定期回访",info:"提高客户使用满意度"},
                {title:"1V1指导",info:"一对一在线指导操作"},
                {title:"臻享服务",info:"专业领域缔造专业服务"},
            ],
            item2_list:[
                {title:"项目建立",info:"围绕校长、教务老师、上课老师、财务等角色建立项目组"},
                {title:"系统培训",info:"以角色、常用功能为维度，进行1对1线上培训"},
                {title:"数据导入",info:"手把手帮助机构将数据导入系统中，确保数据准确，快速上线 "},
                {title:"系统实操",info:"帮助老师进行功能实操，并针对问题进行详细解答 "},
                {title:"项目交付",info:"系统使用确保无误后，将项目交接至机构"},
            ],
            item3_list:[
                {img:"",title:"曼舞空间舞蹈"},
                {img:"",title:"舞+舞"},
                {img:"",title:"咔咔舞蹈家园"},
                {img:"",title:"乐音音乐"},
                {img:"",title:"新星教育"},
                {img:"",title:"沐点艺术空间"},
                {img:"",title:"木兰ML舞蹈"},
                {img:"",title:"小红花艺术团"},
                {img:"",title:"莱音音乐培训中心"},
                {img:"",title:"哈妮公主舞蹈艺术中心"},
                {img:"",title:"清风围棋"},
                {img:"",title:"0531街舞"},
                {img:"",title:"风之舞"},
                {img:"",title:"钢花艺校"},
                {img:"",title:"棒棒堂"},
            ],

        }
    },
    created(){
        this.item1_list.map((item, i) => {
            this.$set(item, "hover_", false);
        })
    },
    mounted(){

    },
    methods:{
        leaveItem1(){
            this.item1_list.map((item, i) => {
                this.$set(item, "hover_", false);
            })
        },
        openDialog:function(title,type){//type:(0机构,1微官网)
              this.$parent.$refs.openPop.openDialog(title,type);
          }
    }
}
</script>

<style scoped lang="less">
    .banner {
        width: 100%;
        height: 480px;
        margin-top: 80px;
        background: url("https://cdntest.yizhiniao.com/newWebsite_/service/banner.jpg") no-repeat center;

        .banner-center {
            height: 100%;
            position: relative;
        }

        .banner-info {
            position: absolute;
            bottom: 90px;
            left: 95px;
            text-align: left;
        }
    }
    .item_1{
        padding-top:180px;
        .item-contents{
            padding:90px 90px 118px;
            ul{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width:1020px;
                height:540px;
                margin: 0 auto;
                li{
                    width:298px;
                    height:238px;
                    border: 1px solid #FFABAD;
                    background: #FFFCFC;
                    transition:0.3s;
                    padding-top:60px;
                    position:relative;

                    .title_info{
                        position:absolute;
                        bottom:40px;
                        text-align: center;
                        width: 100%;
                        .info{
                            font-size: 20px;
                            font-weight: 500;
                            color: #646464;
                            line-height: 28px;
                        }
                    }
                    &.jqhover{
                        border:none;
                        background: #FFFFFF;
                        box-shadow: 0px 2px 40px 0px #F1F1F1;
                        margin-top:-10px;
                        .title_info {
                            .info{
                                color: #1E1E1E;
                            }
                        }
                    }
                }
            }
        }
    }
    .item_2{
        width:100%;
        height:768px;
        padding-top: 182px;
        background: url("https://cdntest.yizhiniao.com/newWebsite_/service/item2_bg.jpg") no-repeat center;
        .item-title{
            margin:0 auto 80px;
            .title2{
                color:#fff;
            }
        }
        .item-contents{
            ul{
                width: 1160px;
                display: flex;
                justify-content: space-between;
                margin:0 auto;
                li{
                    width: 200px;
                    height:270px;
                    color: #fff;
                    text-align: center;
                    .title{
                        font-size:20px;
                        line-height:28px;
                    }
                    .image{
                        margin:60px auto;
                        width:60px;
                        height: 60px;
                    }
                    .info{
                        font-size:14px ;
                        line-height: 20px;
                        white-space: normal;
                        text-align: left;
                    }
                }
            }

        }
    }
    .item_3{
        padding-top: 158px;
        .item-contents{
            padding:80px 20px 100px;
            ul{
                margin:0 auto;
                width: 1160px;
                height: 1200px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li{
                    width:360px;
                    height:240px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 40px 0px rgba(225, 220, 220, 0.5);
                    .image{
                        width: 100%;
                        height: 180px;
                    }
                    .title{
                        width: 100%;
                        height:60px;
                        line-height: 60px;
                        text-align: center;
                        font-size: 20px;
                        font-weight: 500;
                        color: #4A4A4A;
                    }
                }
            }
        }
    }
    .item_4{
        .item-title{
            width: 100%;
            height:355px;
            padding:140px 0 145px;
            background:url("https://cdntest.yizhiniao.com/newWebsite_/common/tiao1_bg.png") no-repeat center;
        }
        .item-contents{
            margin-top: -86px;
            .info{
                width: 1028px;
                margin:0 auto 78px;
                li{
                    width: 100%;
                    height:80px;
                    padding-left: 28px;
                    background:url("https://cdntest.yizhiniao.com/newWebsite_/service/qustion.png") no-repeat left;
                    >div{
                        text-align: left;
                        font-size: 18px;
                        line-height: 40px;
                    }
                    .question{
                        color:#1e1e1e;
                        font-weight: 500;
                    }
                    .answer{
                        color:#4A4A4A;
                    }
                    &:not(:last-child){
                        margin-bottom:40px;
                    }

                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/service.vue